import { render } from "./OfferSpecification.vue?vue&type=template&id=2b80e0e1"
import script from "./OfferSpecification.vue?vue&type=script&lang=js"
export * from "./OfferSpecification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__